export default {
  methods: {
    resendVerification() {
      return new Promise((resolve, reject) => {
        if (!this.$store.getters.user.verified) {
          this.$reqs.post(`/users/${this.$store.getters.user.id}/resend_verification`)
            .then((result) => {
              resolve(result);
              this.$swal({
                title: 'Success',
                text: result.data.message,
                type: 'success',
              });
            })
            .catch((error) => {
              reject(error);
              this.$swal({
                title: 'Error',
                text: error.data.message,
                type: 'error',
              });
            });
        } else {
          this.$swal({
            title: 'Already verified!',
            text: 'You are already verified',
            type: 'info',
          });
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/utils/verification/verification.js